<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class=" toolbartitle_50" >
            <h1 ><v-icon large>mdi-file-cad</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <v-row>
      <v-col md="4" v-if="item['image']">
        <ImageView :item="item" filter="150x150" :edit="userHasAccess('designfile_edit')"  />
      </v-col>
      <v-col md="8">
        <DesignFileForm
          ref="updateForm"
          v-if="item"
          :values="item"
          :errors="violations"
        />
     </v-col>
   </v-row>
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import DesignFileForm from '../../components/designfile/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import FileMixin from '../../mixins/FileMixin';
import AccessMixin from '../../mixins/AccessMixin';
import ImageView from '../../components/ImageView.vue';

const servicePrefix = 'DesignFile';

export default {
  name: 'DesignFileUpdate',
  servicePrefix,
  mixins: [UpdateMixin,FileMixin,AccessMixin],
  components: {
    Loading,
    Toolbar,
    DesignFileForm,
    ImageView
  },
  data() {
    return {
      item: {
      }
    };
  },

  computed: {
    ...mapFields('designfile', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('designfile', ['find'])

  },

  methods: {
    ...mapActions('designfile', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
